import styled from "styled-components";

export const GroupInputs = styled.div`
    flex: 1;
`

export const Span = styled.span`
    margin: .5rem !important;
`